import { useState } from 'react'
import { useQuery } from 'react-query'
import ProjectService from '../../../services/ProjectService'
import { FlexProjectItem } from '../project-details/ProjectDetails'
import LeftPanel from './left-panel/LeftPanel'
import RightPanel from './right-panel/RightPanel'

type Props = {
  projectId: string
}

const AssociatedFLEXProjects = (props: Props) => {
  const [selectedProjectId, setSelectedProjectId] = useState<string>()
  const flexProjectsQuery = useQuery(
    ['flex-projects', props.projectId],
    async () => {
      const result = await ProjectService.getGMAWBFlexProjects(props.projectId)
      return result.data as Omit<FlexProjectItem, 'isActive'>[]
    },
    {
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
    }
  )

  return (
    <div className="flex border border-gray-300 divide-x-2 divide-gray-300 h-[30rem]">
      <LeftPanel
        flexProjectQuery={flexProjectsQuery}
        selectedProjectId={selectedProjectId}
        setSelectedProjectId={setSelectedProjectId}
      />
      <RightPanel
        selectedProjectId={selectedProjectId}
        isFlexProjectsLoading={flexProjectsQuery.isFetching}
      />
    </div>
  )
}

export default AssociatedFLEXProjects
